import { render, staticRenderFns } from "./mailings-form-sender-select.vue?vue&type=template&id=afc8f630&"
import script from "./mailings-form-sender-select.vue?vue&type=script&lang=js&"
export * from "./mailings-form-sender-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports